import {
  FETCH_CAR_TYPES,
  FETCH_CAR_TYPES_SUCCESS,
  FETCH_CAR_TYPES_FAILED,
  EDIT_CAR_TYPE
} from "../store/types";
import store from '../store/store';
import {
  createRecordId,
  deleteAppFile,
  deleteRecord,
  listRecords,
  saveRecord,
  subscribeToRecords,
  uploadAppFile,
} from '../data/appRecords';

export const fetchCarTypes = () => (dispatch) => {
  dispatch({
    type: FETCH_CAR_TYPES,
    payload: null
  });

  const publish = (data) => {
    if (data && Object.keys(data).length) {
      const arr = Object.entries(data).map(([id, value]) => ({ ...value, id }));
      dispatch({
        type: FETCH_CAR_TYPES_SUCCESS,
        payload: arr
      });
    } else {
      dispatch({
        type: FETCH_CAR_TYPES_FAILED,
        payload: store.getState().languagedata.defaultLanguage.no_cars
      });
    }
  };

  let unsubscribe = () => {};
  try {
    unsubscribe = subscribeToRecords('cartypes', () => {
      listRecords('cartypes').then(publish).catch((error) => {
        dispatch({ type: FETCH_CAR_TYPES_FAILED, payload: error.message });
      });
    });
  } catch (error) {
    dispatch({ type: FETCH_CAR_TYPES_FAILED, payload: error.message });
    return unsubscribe;
  }
  listRecords('cartypes').then(publish).catch((error) => {
    dispatch({ type: FETCH_CAR_TYPES_FAILED, payload: error.message });
  });
  return unsubscribe;
};

export const editCarType = (cartype, method) => async (dispatch) => {
  dispatch({
    type: EDIT_CAR_TYPE,
    payload: { method, cartype }
  });
  try {
    const id = cartype.id || createRecordId();
    if (method === 'Delete') {
      await deleteRecord('cartypes', id);
      await deleteAppFile('cartypes', id);
      return;
    }

    const data = { ...cartype, id };
    if (method === 'Add' || method === 'UpdateImage') {
      data.image = await uploadAppFile('cartypes', id, cartype.image);
    }
    await saveRecord('cartypes', id, data);
  } catch (error) {
    dispatch({ type: FETCH_CAR_TYPES_FAILED, payload: error.message });
  }
}